import { withCompController } from '@wix/editor-elements-integrations';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import type {
  IHamburgerOverlayMapperProps,
  IHamburgerOverlayControllerProps,
  IHamburgerOverlayProps,
  IHamburgerOverlayStateValues,
} from '../HamburgerOverlay.props';
import { resetEntranceAnimationsExperiment } from '../../consts';

export default withCompController<
  IHamburgerOverlayMapperProps,
  IHamburgerOverlayControllerProps,
  IHamburgerOverlayProps,
  IHamburgerOverlayStateValues
>(({ mapperProps, stateValues }) => {
  const { compId } = mapperProps;

  const { setSiteScrollingBlocked, experiments = {} } = stateValues;

  const onOpenStateChange = (isOpen: boolean) => {
    setSiteScrollingBlocked(isOpen, compId);
  };

  const shouldResetEntranceAnimations = isExperimentOpen(
    experiments,
    resetEntranceAnimationsExperiment,
  );

  return {
    ...mapperProps,
    onOpenStateChange,
    shouldResetEntranceAnimations,
  };
});
